/**
 * Derived from Angular's version class
 */
export class Version {
    public readonly full: string;
    public readonly major: string;
    public readonly minor: string;
    public readonly patch: string;

    /**
     * Constructor
     */
    constructor(public version: string) {
        this.full = version;
        const parts = version.split('.');
        this.major = parts[0] ?? '0';
        this.minor = parts[1] ?? '0';
        this.patch = parts.slice(2).join('.');
    }
}
